module.exports = __webpack_public_path__ + "img/3.d2eca4e9.svg";